import React from 'react';
import styled from 'styled-components';
import Container from '../container';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import Chevron from '../../images/svg/chevron-icon.svg';
import Button from '../button';
import parseStoryblokLink from '../../utils/parseStoryblokLink';

const HeroSlideContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 0 0 100%;
  min-width: 0;
  position: relative;
`;

const ContentContainer = styled.div`
  z-index: 3;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
`;

const InnerContentContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 3;
  padding-top: 140px;
  padding-bottom: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 85px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
`;

const NavigationControlsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 52px;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -1.04px;
  max-width: 536px;
  user-select: none;
`;

const Description = styled.p`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.4px;
  max-width: 460px;
  user-select: none;
`;

const StyledButton = styled(Button)`
  width: fit-content;
`;

const BackgroundAssetContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: hidden;
  user-select: none;
`;

const Image = styled(LazyImage)`
  height: 100%;
  width: 100%;
`;

const NavigationControlButton = styled.button`
  width: 48px;
  height: 48px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  background-color: transparent;
  color: #fff;
  svg {
    height: 20px;
  }
`;

const GradientOverlay = styled.div<{ $opacity?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(22, 22, 22, calc(${(props) => props.$opacity} / 100)) 50%,
    rgba(22, 22, 22, 0) 100%
  );
  z-index: 2;
`;

export default function HeroSlide({
  titleText,
  descriptionText,
  ctaText,
  ctaLink,
  backgroundAsset,
  imageGradientOverlayOpacity,
  nextSlide,
  previousSlide
}: {
  titleText: string;
  descriptionText: string;
  ctaText: string;
  ctaLink: any;
  backgroundAsset: string;
  imageGradientOverlayOpacity: {
    value: number;
  };
  nextSlide: () => void;
  previousSlide: () => void;
}) {
  return (
    <HeroSlideContainer className="embla__slide">
      <ContentContainer>
        <Container>
          <InnerContentContainer></InnerContentContainer>
        </Container>
      </ContentContainer>
      <BackgroundAssetContainer>
        <ImageContainer>
          <GradientOverlay $opacity={imageGradientOverlayOpacity.value || 15} />

          <Image
            fluid={getFluidGatsbyImage(backgroundAsset, {
              maxWidth: 1920
            })}
          />
        </ImageContainer>
      </BackgroundAssetContainer>
    </HeroSlideContainer>
  );
}
